// extracted by mini-css-extract-plugin
export default {"container":"CommunicationPhoneCalls_container__3NoRS"};